/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
const CreateCommentDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    /* #__PURE__ */ parsers.object([
        ['fileId', codecNumber, 'file_id'],
        ['line', codecNumber],
    ]),
    /* #__PURE__ */ parsers.object([['workId', codecNumber, 'work_id']]),
]);
export const CreateCommentData = CreateCommentDataParser;
